import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLoader = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "L9",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "25 25 49 49",
	enableBackground: "new 0 0 0 0",
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		d: "M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50",
		children: /* @__PURE__ */ _jsx("animateTransform", {
			attributeName: "transform",
			attributeType: "XML",
			type: "rotate",
			dur: "1s",
			from: "0 50 50",
			to: "360 50 50",
			repeatCount: "indefinite"
		})
	})
});
export default SvgLoader;
